import { CheckCircle, Zap, Smartphone, Tv, Wifi } from "lucide-react";
import servicesImage from "../assets/images/services-hero.jpg"; // replace with your hero image
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ServicesPage() {
  return (
    <div className="bg-gray-50">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <section className="relative bg-[#007AFF] text-white py-28 overflow-hidden">
        <div className="w-4/5 mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-12">
          {/* LEFT CONTENT */}
          <div className="relative z-10 text-center md:text-left">
            <h1 className="text-4xl sm:text-6xl md:text-6xl font-bold mb-4">
              Our Services
            </h1>
            <p className="text-lg md:text-xl max-w-lg mx-auto md:mx-0 leading-relaxed">
              From utilities to digital solutions, Dotti Verify makes your daily
              transactions seamless, secure, and lightning-fast.
            </p>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative">
            <img
              src={servicesImage}
              alt="Services Hero"
              className="rounded-2xl shadow-2xl w-full h-[400px] md:h-[500px] object-cover"
            />
            {/* Dark overlay (optional for better text readability) */}
            <div className="absolute inset-0 bg-black/20 rounded-2xl"></div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 w-4/5 mx-auto">
        <h2 className="text-2xl sm:text-4xl md:text-4xl font-bold text-gray-900 text-center mb-12">
          What We Offer
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Electricity Bills */}
          <div className="bg-white rounded-2xl p-8 shadow hover:shadow-xl transition text-center">
            <Zap className="w-14 h-14 text-[#007AFF] mx-auto mb-6" />
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold mb-4">
              Electricity Bills
            </h3>
            <ul className="text-gray-600 space-y-2 text-m sm:text-lg md:text-lg">
              <li>PHCN, EEDC, EKEDC & more</li>
              <li>Instant payment</li>
              <li>No hidden fees</li>
              <li>24/7 availability</li>
            </ul>
          </div>

          {/* Airtime & Data */}
          <div className="bg-white rounded-2xl p-8 shadow hover:shadow-xl transition text-center">
            <Smartphone className="w-14 h-14 text-[#007AFF] mx-auto mb-6" />
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold mb-4">
              Airtime & Data
            </h3>
            <ul className="text-gray-600 space-y-2 text-m sm:text-lg md:text-lg">
              <li>All networks supported</li>
              <li>Instant delivery</li>
              <li>Best market rates</li>
            </ul>
          </div>

          {/* Cable TV */}
          <div className="bg-white rounded-2xl p-8 shadow hover:shadow-xl transition text-center">
            <Tv className="w-14 h-14 text-[#007AFF] mx-auto mb-6" />
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold mb-4">
              Cable TV
            </h3>
            <ul className="text-gray-600 space-y-2 text-m sm:text-lg md:text-lg">
              <li>DStv, GOtv, StarTimes</li>
              <li>Automatic renewal</li>
              <li>Zero interruption</li>
            </ul>
          </div>

          {/* Internet Bills */}
          <div className="bg-white rounded-2xl p-8 shadow hover:shadow-xl transition text-center">
            <Wifi className="w-14 h-14 text-[#007AFF] mx-auto mb-6" />
            <h3 className="text-xl sm:text-2xl md:text-2xl font-semibold mb-4">
              Internet Bills
            </h3>
            <ul className="text-gray-600 space-y-2 text-m sm:text-lg md:text-lg">
              <li>All ISPs supported</li>
              <li>Quick processing</li>
              <li>Reliable connections</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="bg-gray-100 py-24">
        <div className="w-4/5 mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-2xl sm:text-4xl md:text-4xl font-bold mb-6">
              Why Choose Us
            </h2>
            <p className="text-m sm:text-lg md:text-lg text-gray-700 mb-6 leading-relaxed">
              At Dotti Verify, we’re more than just bill payments. We provide
              trust, speed, and reliability with every transaction.
            </p>
            <ul className="space-y-4 text-gray-600 text-m sm:text-lg md:text-lg">
              <li className="flex items-center gap-3">
                <CheckCircle className="text-green-500 w-6 h-6" />
                100% Secure Transactions
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-green-500 w-6 h-6" />
                24/7 Customer Support
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-green-500 w-6 h-6" />
                Best Market Rates
              </li>
              <li className="flex items-center gap-3">
                <CheckCircle className="text-green-500 w-6 h-6" />
                Trusted by Thousands
              </li>
            </ul>
          </div>
          <div></div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 text-center bg-[#007AFF] text-white">
        <h2 className="text-2xl sm:text-4xl md:text-4xl  font-bold mb-6">
          Ready to Experience Seamless Services?
        </h2>
        <p className="text-m sm:text-lg md:text-lg max-w-2xl mx-auto mb-10">
          Join thousands of users enjoying instant bill payments, secure
          airtime/data top-ups, and reliable digital services today.
        </p>
        <button className="bg-white text-[#007AFF] px-10 py-4 rounded-full font-semibold shadow-lg hover:bg-gray-200 transition text-lg">
          Get Started Now
        </button>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
